export class Path {
	constructor(parent, node) {
		this.parent = parentPath
		this.node = node
	}
	ancestors() {
		const result = []
		let parent = this.parent
		while (parent != null) {
			result.unshift(parent)
			parent = parent.parent
		}
		return result
	}
}
